<h2>Beacon Logs for Scenario</h2>
<div class="row">
    <div class="col-md-4">
        <div *ngIf="this.overview.length == 0">This scenario has no logs for Bluetooth beacons.</div>
        <button class="btn btn-primary btn-sm" (click)="deleteSelected()">Delete Selected</button>
        <button class="btn btn-info btn-sm" style="float:right" (click)="refresh()">Refresh</button>
        <br><br>
        <table  *ngIf="this.overview.length > 0" class="table table-bordered">
            <thead>
                <tr>
                    <th >Phone Info  <i class="bi bi-arrow-down-up" style="margin-left:10px" (click)="sortCol('phoneInfo')"></i></th>
                    <th>Records</th>
                    <th>Date <i class="bi bi-arrow-down-up" style="margin-left:10px" (click)="sortCol('date')"></i></th>
                    <th>Select</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let o of overview">
                    <td  class="link" (click)="selectPhoneInfo(o.phoneInfo)">{{o.phoneInfo}}</td>
                    <td>{{o.count}}</td>
                    <td>{{o.date | date: 'shortDate'}}</td>
                    <td><input type="checkbox" [(ngModel)]="o.selected"></td>

                </tr>
            </tbody>
        </table>
    </div>
    <div class="col-md-8">
        <button class="btn btn-primary btn-sm" (click)="refreshSensorDisplay()" >Refresh</button>
        <!-- {{sensordisplay | json}} -->
        <br>
        <!-- { "days": 8, "hours": 13, "minutes": 58, "seconds": 56 } -->
        <!-- { "id": 5, "scenarioId": 48, "phoneInfo": "B9561", "dateCreated": "2024-02-03T20:11:49.6067454", "sensorValues": "{\"LEL\":15,\"PID\":120,\"O2\":17.3}" } -->
        <div class="center-block-parent" style="border:solid 1px black;border-radius:10px;max-width:300px;padding:20px;margin:20px;background-color: lightgray;">
            <h5>Sensor Display of {{sensordisplay.phoneInfo}}</h5>

            <span>{{sensordisplay.difference?.days}} d: {{sensordisplay.difference?.hours}} h: {{sensordisplay.difference?.minutes}} m: {{sensordisplay.difference?.seconds}} s ago</span>
            <!-- <span>{{ sensordisplay.difference | json}}</span> -->
            <br><br>
            <table class="sensordisplay" style="background-color: white;">
                <tbody>
                    <tr *ngFor="let o of displayarray">
                        <td>{{o.sensorName}}</td>
                        <td>{{o.sensorValue}}</td>
                        <td>{{o.sensorUnit}}</td>
                    </tr>
                </tbody>
            </table>
        </div>
        <button class="btn btn-primary btn-sm" (click)="downloadFile(null)" >Download</button>

        <br>
        <table  *ngIf="this.beacongroups.length > 0" class="table table-bordered">
            <thead>
                <tr>
                    <th >Phone Info  <i class="bi bi-arrow-down-up" style="margin-left:10px" (click)="sortCol('phoneInfo')"></i></th>
                    <th>Records</th>
                    <th>RSSI min</th>
                    <th>RSSI max</th>
                    <th>Dist min</th>
                    <th>Dist max</th>
                    <th>Rssi 1 meter</th>
                    <th>Environmental Factor</th>

                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let o of beacongroups">
                    <td  class="link" (click)="selectBeacon(o.name)">{{o.name}}</td>
                    <td>{{o.nrecords}}</td>
                    <td>{{o.rssi_min}}</td>
                    <td>{{o.rssi_max}}</td>
                    <td>{{o.dist_min | number: '1.3-3'}}</td>
                    <td>{{o.dist_max | number: '1.3-3'}}</td>
                    <td>{{o.rssi1m}}</td>
                    <td>{{o.envFactor}}</td>
                </tr>
            </tbody>
        </table>   
        <b>Averaged Distance versus Time</b>
        <app-scatter [Id]="'scatter3'" #scatter3 ></app-scatter>
        <b>Distance versus Time</b>
        <app-scatter [Id]="'scatter2'" #scatter2 ></app-scatter>
        <b>Rssi versus Time</b>
        <app-scatter [Id]="'scatter1'" #scatter1 ></app-scatter>
    </div>
</div>

